import React, { useState, useEffect } from "react";
import DrawArea from "./DrawPdfArea";
import { Document, Page, pdfjs } from "react-pdf";
import { MdNavigateNext } from "react-icons/md";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

interface PreviewPdfPageProps {
  pdf: string;
  pageChange: (pageNumber: number) => void;
  getPaths: (el: any) => void;
  flag: string;
  getBounds: (obj: any) => void;
  changeFlag: () => void;
  cursor: string;
  buttonType: string;
  resetButtonType: () => void;
  pdfError: boolean;
  pdfSetError: any;
  strokeColor: string;
  magnifierGlass: boolean;
  text: any;
  setText: any;
  pageNum: number;
}

const PreviewPdf: React.FC<PreviewPdfPageProps> = (props) => {
  const { pdf } = props;
  const [numPages, setNumPages] = useState<number | null>(null);
  const [pageNumber, setPageNumber] = useState<number>(1);
  const fileName = props?.pdf?.split('/').pop();
  const [newWidth, setNewWidth] = useState<number>(0);
  const [newHeight, setNewHeight] = useState<number>(0);

  const onDocumentLoadSuccess = ({ numPages }: { numPages: number }) => {
    setNumPages(numPages);
    setPageNumber(1);
  }

  const onPageLoadSuccess = (page: any) => {
    const pdfWidth = page.originalWidth;
    if (pdfWidth > 800) {
      setNewWidth(1110);
      setNewHeight(800);
    } else if (pdfWidth > 550) {
      setNewWidth(820);
      setNewHeight(1150);
    } else {
      setNewWidth(820);
      setNewHeight(1150);
    }
  };

  useEffect(() => {
    if (newWidth && newHeight) {
      localStorage.setItem("pdfEditNewWidth", String(newWidth));
    }
  }, [newWidth, newHeight]);

  useEffect(() => {
    props.pageChange(pageNumber);
  }, [pageNumber, props]);

  const changePage = (offset: number) => {
    setPageNumber((prevPageNumber) => prevPageNumber + offset);
  }

  const previousPage = () => {
    changePage(-1);
  }

  const nextPage = () => {
    changePage(1);
  }

  const onDocumentLoadError = (err: any) => {
    console.error("onDocumentLoadError=>", err);
    props.pdfSetError(true);
  };

  return (
    <>
      {props?.pdfError ?
        <>
          <div className="text-center mt-4">
            <p>ไม่พบไฟล์ PDF ที่จะทำการแก้ไข</p>
          </div>
        </>
        :
        <>
          <div className="text-center mt-2">
            <p style={{ fontSize: 18 }}>
              หน้าที่ {pageNumber || (numPages ? 1 : "-")} ใน {numPages || "-"}
            </p>
          </div>
          <div className="d-flex align-items-center justify-content-between px-4">
            <div className="">
              <button
                className="rounded-circle btn btn-primary border border-light"
                disabled={pageNumber <= 1}
                onClick={previousPage}
                style={{
                  height: 50,
                  width: 50,
                  display: numPages !== null && numPages > 1 ? "block" : "none",
                }}
              >
                <MdNavigateNext style={{ fontSize: 20, color: "#fff", rotate: "180deg" }} />
              </button>
            </div>
            <div className="">
              <Document
                file={pdf}
                onSourceError={(err: any) => { console.log("onSourceError", err) }}
                onSourceSuccess={() => console.log("SUCCESS")}
                onLoadSuccess={onDocumentLoadSuccess}
                onLoadError={onDocumentLoadError}
              >
                <DrawArea
                  getPaths={props.getPaths}
                  page={pageNumber}
                  flag={props.flag}
                  getBounds={props.getBounds}
                  changeFlag={props.changeFlag}
                  cursor={props.cursor}
                  buttonType={props.buttonType}
                  resetButtonType={props.resetButtonType}
                  fileName={fileName}
                  strokeColor={props.strokeColor}
                  magnifierGlass={props.magnifierGlass}
                  pdf={pdf}
                  text={props.text}
                  setText={props.setText}
                  pageNum={props.pageNum}
                  newWidth={newWidth}
                  newHeight={newHeight}
                >
                  <Page
                    pageNumber={pageNumber}
                    onLoadSuccess={onPageLoadSuccess}
                    width={newWidth}
                    height={newHeight}
                  />
                </DrawArea>
              </Document>
            </div>
            <div>
              <button
                className="rounded-circle btn btn-primary border border-light"
                disabled={pageNumber >= (numPages || 0)}
                onClick={nextPage}
                style={{
                  height: 50,
                  width: 50,
                  display: numPages !== null && numPages > 1 ? "block" : "none",
                }}>
                <MdNavigateNext style={{ fontSize: 20, color: "#fff" }} />
              </button>
            </div>
          </div>
        </>
      }

    </>
  );
};

export default PreviewPdf;